import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actualizarDetallesCargaEntrante } from '../../actions/controlDiario'
import DetalleDescargaConMermasView from '../../components/listados/controlDiario/DetalleDescargaConMermasView'

function DetalleDescargaConMermas (props) {
  const { detalle, agrupado = false, actualizarDetallesCargaEntrante, fechaDesde, fechaHasta } = props

  useEffect(() => {
    if (agrupado) {
      actualizarDetallesCargaEntrante(fechaDesde, fechaHasta, null, detalle.nombreCereal)
    } else {
      actualizarDetallesCargaEntrante(detalle.fechaDeDescarga, null, detalle.exportador, detalle.nombreCereal)
    }
  }, [actualizarDetallesCargaEntrante, detalle, fechaDesde, fechaHasta, agrupado])

  return (
    <DetalleDescargaConMermasView />
  )
}

const mapStateToProps = (state) => ({
  fechaDesde: state.stock.fechaDReporteDescarga,
  fechaHasta: state.stock.fechaHReporteDescarga
})

const mapActionsToProps = {
  actualizarDetallesCargaEntrante
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(DetalleDescargaConMermas)
